module.exports = __webpack_public_path__ + "static/img/cha3-bg.33dcd32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/cha3-bg.png
// module id = hPV7
// module chunks = 1